import {IntermediatePart} from "../../intermediatePart";

export default class ShowerDrain extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_drain';
    this.partName = 'Shower Drain';
    this.translateId = "visualizer.bathroom.shower.shower_drain";
    this.homePageTitle = 'Shower Drain';
    this.visible = false;
    this.layerPriority = 14;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerDrain())
  }

  setLayers(layout) {
    const showerParent = this.getParent();
    if (!showerParent.showerFloorIsActive || showerParent.showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    })
    return conditions
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    this.activeFeature = filteredFeatures[0];
    this.placeholderFeature = filteredFeatures[0];
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.ShowerDrain;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
